module.exports = __webpack_public_path__ + "img/nav-btn.4ef40894.svg";